module.exports = __webpack_public_path__ + "fonts/MADETommySoftBoldPERSONALUSE.80284b89.otf";